import { FC } from 'react'
import { SecurityAvatar } from '@/securities/securityAvatar'
import { ORDER_FORM_COPY } from '@/locales/en'
import Money from '@/common/models/money'

interface SecuritySummaryItemProps {
    securityCode: string
    amount: number
    units: number
    weight: number
    relevantPrice: number
}

export const SecuritySummaryItem: FC<SecuritySummaryItemProps> = ({
    securityCode,
    weight,
    amount,
    units,
    relevantPrice,
}) => {
    return (
        <div className="w-full self-stretch justify-between  inline-flex items-center font-['Inter'] mr-2">
            <div className="self-stretch inline-flex justify-start items-center gap-2.5">
                <div className="h-full inline-flex justify-start items-center">
                    <SecurityAvatar securityCode={securityCode} height={6} width={6} />
                </div>
                <div className="inline-flex flex-col justify-start items-start gap-1">
                    <div className="text-center justify-start text-black text-sm font-normal leading-5">
                        {securityCode}
                    </div>
                    <div className="text-center justify-start text-content-secondary text-xs font-normal leading-4">
                        {weight.toFixed(2)}%
                    </div>
                </div>
            </div>
            <div className="text-right">
                <div className="text-black text-sm">{Money.of(amount).toString()}</div>
                <div className="text-content-secondary text-xs">
                    {units}
                    {ORDER_FORM_COPY.unitsAt}
                    {Money.of(relevantPrice).toString()}
                </div>
            </div>
        </div>
    )
}
